import ThemeContext from "config/context/themeContext";
import { useContext } from "react";
import styles from "./Select.module.css";
const Select = ({ value, onChange, children, className, ...props }) => {
  const { dark } = useContext(ThemeContext);

  return (
    <select
      value={value}
      onChange={onChange}
      className={`${styles.select} ${dark ? styles.dark : ""} ${
        className ?? ""
      }`}
      {...props}
    >
      {children}
    </select>
  );
};

export default Select;
